import Vue from 'vue';

export async function getInitialState() {
  return (await Vue.$http.get('content/')).data;
}


export default (initialState = {}) => ({
  namespaced: true,
  state: initialState,
  getters: {
    skillToCategory: state => Object.entries(state.skills).reduce((acc, [category, skills]) => {
      skills.forEach((skill) => {
        acc[skill] = category;
      });
      return acc;
    }, {}),
    qualificationsSet: state => Object.values(state.qualifications)
      .reduce((acc, qualifications) => {
        qualifications.forEach((q) => {
          acc.add(q);
        });
        return acc;
      }, new Set()),
  },
});
